"use client";

import { useQuery } from "@tanstack/react-query";

import { getFullUserLocations } from "@/app/actions/get-full-user-locations";
import { useAuth } from "@/provider/auth-provider";

export const useLocations = () => {
  const { user, userInfo } = useAuth();

  const queryKeys: string[] = ["locations"];

  if (userInfo?.role !== "ADMIN") {
    queryKeys.push(user?.user_metadata.locationId ?? "");
  }

  return useQuery({
    queryKey: queryKeys,
    queryFn: async () => await getFullUserLocations(),
    enabled: !!userInfo?.role,
  });
};
